import { gql } from "@apollo/client";

export const DEPARTMENT_FRAGMENT = gql`
  fragment DepartmentPart on Department {
    id
    name
    code
  }
`;

export const DEPARTMENTS = gql`
  query DepartmentsQuery($where: DepartmentsFiltersInput!) {
    departments(where: $where) {
      hasMore
      results {
        ...DepartmentPart
      }
    }
  }
  ${DEPARTMENT_FRAGMENT}
`;
